module.exports = __webpack_public_path__ + "img/pwd_hide.aff4cfa0.svg";